import React, {FC, useRef} from 'react'
import {
    TablePagination,
} from '@mui/material';
import PagePagination from '@mui/lab/Pagination';
import clsx from 'clsx';

/**
 * @deprecated
 */
export interface IPagination {
    /** the total number of results */
    count: number,
    /** the number of results per page */
    rowsPerPage: number,
    /** the current page number */
    page: number,
    /** (optional) an array of numbers that a user can select from to determine number of results on each page */
    rowsPerPageOptions?: Array<number>,
    /** (optional) false by default. if true, scroll to component's position when the page changes */
    scrollToBottomOnPageChange?: boolean,
    /** (optional) the handler for a page number selection for TablePagination */
    onPageChange?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null, page: number) => void,
    /** (optional) the handler for a page number selection for PagePagination */
    pagePaginationHandler?: ((event: React.ChangeEvent<unknown>, page: number) => void) | undefined,
    /** (optional) the handler for selecting a 'results per page' for TablePagination */
    onRowsPerPageChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined,
    /** (optional) determines TablePagination or PagePagination TODO EL (See storybook) */
    variant?: 'tablePagination' | 'pagePagination',
    /** (optional) applied directly to the top-level component  */
    className?: string,
}
/** Control pagination for report data
 * @deprecated
 */
const Pagination: FC<IPagination> = ({
    count,
    rowsPerPage,
    page,
    onPageChange = () => { },
    onRowsPerPageChange,
    rowsPerPageOptions,
    pagePaginationHandler,
    scrollToBottomOnPageChange = false,
    className,
    variant = 'tablePagination',
    ...props }: IPagination) => {


    const pageRef = useRef<null | HTMLDivElement>(null);

    const handleOnPageChange = (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null, newPage: number) => {
        onPageChange(event, newPage);
        if (scrollToBottomOnPageChange) {
            pageRef.current?.scrollIntoView({ behavior: "smooth", block: 'end' })
        }
    }

    const handlePagePaginationChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
        if (!pagePaginationHandler) return;
        pagePaginationHandler(event, newPage);
        if (scrollToBottomOnPageChange) {
            pageRef.current?.scrollIntoView({ behavior: "smooth", block: 'end' })
        }
    }

    return (
        variant !== 'pagePagination' ? <TablePagination
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleOnPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
            rowsPerPageOptions={rowsPerPageOptions}
            className={clsx(className)}
            ref={pageRef}
            {...props}
        /> : <PagePagination className={clsx(className)} onChange={handlePagePaginationChange} page={page} count={count} variant="outlined" color='primary' ref={pageRef} />
    )
}

export default Pagination;